const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const AUTH_KEY = 'ppt_auth_state';

// Attempt to login using backend API
export async function login(email, password) {
  try {
    const res = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    if (res.ok) {
      const data = await res.json();
      localStorage.setItem(AUTH_KEY, JSON.stringify({ email, token: data.token, loggedInAt: Date.now() }));
      return true;
    }
    return false;
  } catch (error) {
    console.error('Login error', error);
    return false;
  }
}

export function logout() {
  localStorage.removeItem(AUTH_KEY);
}

export function isAuthenticated() {
  const authState = localStorage.getItem(AUTH_KEY);
  if (!authState) return false;
  
  try {
    const parsed = JSON.parse(authState);
    // Optional: Check if token exists and hasn't expired (30 days)
    const thirtyDays = 30 * 24 * 60 * 60 * 1000;
    if (Date.now() - parsed.loggedInAt > thirtyDays) {
      logout();
      return false;
    }
    return !!parsed.token;
  } catch (e) {
    return false;
  }
}

export function getCurrentUser() {
  const authState = localStorage.getItem(AUTH_KEY);
  return authState ? JSON.parse(authState) : null;
}
